import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTheme } from '@emotion/react';
import { IconButton, TableContainer, Button, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {},
  content: {
    padding: 0
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: '40%'
  }
});

const MembersTable = props => {
  const { 
    accounts,
  } = props;
  
  const classes = useClasses(styles);
  
  return (
    <React.Fragment>
      <CardContent sx={{padding: "0px"}}>
        <PerfectScrollbar>
          <TableContainer sx={{padding: "0px"}}>
            <Table>
              <TableHead sx={{
                backgroundColor: "#fafafa"
              }}>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Website</TableCell>
                  <TableCell>Primary Contact</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {accounts.map(account => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={account.id}
                  >
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {account.name}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <a href={`http://${account.website}`} target="_blank">{account.website}</a>
                    </TableCell>
                    <TableCell>
                      <a href={`mailto:${account.primary_contact_email}`} target="_blank">{account.primary_contact_email}</a>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </PerfectScrollbar>
      </CardContent>
    </React.Fragment>
  );
};

export default MembersTable;
